import { isEmpty } from 'lodash';

export function hasKeys(obj) {
    if (!isEmpty(obj)) {
        return true
    }
    else {
        return false
    }
}

export function isTeacherRole() {
    const roleIds = JSON.parse(localStorage.getItem('role_ids') || '[]');
    return roleIds.some(id => [2, 3].includes(+id));
}
export function isAdminRole() {
    return localStorage.getItem('admin') == 'true' ? true : false;
}
export function isManagerRole() {
    const roleIds = JSON.parse(localStorage.getItem('role_ids') || '[]');
    return roleIds.some(id => +id === 1);
}
export function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
  
    let truncated = text.slice(0, maxLength);
  
    // Avoid cutting off in the middle of a word
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 0) {
      truncated = truncated.slice(0, lastSpace);
    }
  
    return truncated + '...';
  }